import styled from "styled-components";

import { brand_orange_deep } from "../constants/styles";

// Amber "you've hit a limit / this is locked" panel, shared by the catalog's
// visibility cap and the detail page's withheld-recording states. Visual
// language matches the sertifikasi paywall (LessonRecording's SubscribePanel)
// so a locked surface looks the same everywhere in the product.

const Panel = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 24px 28px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 16px;
  color: #92400e;

  strong {
    display: block;
    font-size: 17px;
    margin-bottom: 4px;
    color: ${brand_orange_deep};
  }

  p {
    margin: 0 0 12px;
    font-size: 14px;
    line-height: 1.55;
  }

  [data-theme="dark"] & {
    background: rgba(216, 89, 7, 0.08);
    border-color: rgba(216, 89, 7, 0.32);
    color: #fde68a;
  }
`;

const Icon = styled.span`
  font-size: 28px;
  line-height: 1;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const PrimaryAction = styled.a`
  display: inline-block;
  padding: 10px 22px;
  border-radius: 999px;
  background: ${brand_orange_deep};
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  transition: filter 150ms ease;

  &:hover {
    filter: brightness(0.95);
    color: #fff;
  }
  &:focus-visible {
    outline: 2px solid #fb923c;
    outline-offset: 3px;
  }
`;

const SecondaryAction = styled.a`
  display: inline-block;
  padding: 10px 22px;
  border-radius: 999px;
  background: transparent;
  border: 1px solid ${brand_orange_deep};
  color: ${brand_orange_deep};
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  transition:
    background 150ms ease,
    color 150ms ease;

  &:hover {
    background: ${brand_orange_deep};
    color: #fff;
  }
  &:focus-visible {
    outline: 2px solid #fb923c;
    outline-offset: 3px;
  }

  [data-theme="dark"] & {
    color: #fde68a;
    border-color: #fde68a;
  }
`;

// `actions` is an array of { label, href, variant: 'primary' | 'secondary' }.
export default function UnlockPanel({
  icon = "🔒",
  title,
  children,
  actions = [],
  role = "status",
}) {
  return (
    <Panel role={role}>
      <Icon aria-hidden="true">{icon}</Icon>
      <div>
        <strong>{title}</strong>
        {children}
        {actions.length > 0 && (
          <Actions>
            {actions.map((action) =>
              action.variant === "secondary" ? (
                <SecondaryAction key={action.href} href={action.href}>
                  {action.label}
                </SecondaryAction>
              ) : (
                <PrimaryAction key={action.href} href={action.href}>
                  {action.label}
                </PrimaryAction>
              ),
            )}
          </Actions>
        )}
      </div>
    </Panel>
  );
}
